


















import Vue from "vue";
import Shared from "@/shared";
export default Vue.extend({
    name: "ToolbarLogo",
    props: { mobile: { type: Boolean, required: true } },
    computed: {
        rootUrl(): string {
            return Shared.iProvaUrl;
        }
    }
});
